import React, { Fragment, useEffect, useState } from "react";
import {
  GetCompanyData,
  FormSubmitCompany,
  checkEmpty,
  ShowData,
} from "../Components/Services";
import CommonFrom from "../../../../Common/Components/Form";
import Loading from "../../../../Common/Components/Loading";

function Index() {
  const initialState = {
    data: null,
    loading: true,
  };
  const [state, setstate] = useState(initialState);
  const handler = () => {
    setstate({ ...state, loading: true });
    GetCompanyData().then(data => {
      setstate({ ...state, loading: false, data: data });
    });
  };
  const submit = data => {
    setstate({ ...state, loading: true });
    FormSubmitCompany(data).then(() => {
      setstate({ ...state, loading: false });
      handler();
    });
  };

  useEffect(() => {
    handler();
  }, []);

  return (
    <>
      {state.loading ? (
        <Loading count={1} col={12} height={300} />
      ) : (
        <Fragment>
          {checkEmpty(state.data) ? (
            <CommonFrom
              form={[
                {
                  label: "نام کمپانی ",
                  size: "col-md-12",
                  classNames: "mt-2",
                  placeholder: "نام کمپانی را وارد کنید ",
                  name: "name_co",
                  value: ShowData(state.data, "name_co"),
                  type: "text",
                },
                {
                  label: " نام مدیر کمپانی",
                  size: "col-md-6 ",
                  classNames: "mt-2",
                  placeholder: "نام مدیر را وارد کنید",
                  name: "Ceoname_co",
                  value: ShowData(state.data, "Ceoname_co"),
                  type: "text",
                },
                {
                  label: " آدرس سایت ",
                  size: "col-md-6 ",
                  classNames: "mt-2",
                  placeholder: "آدرس سایت خود را وارد کنید",
                  name: "Sitelink_co",
                  value: ShowData(state.data, "Sitelink_co"),
                  type: "text",
                },
                {
                  label: " آدرس ",
                  size: "col-md-12 ",
                  classNames: "mt-2",
                  placeholder: "نشانی خود را وارد کنید",
                  name: "Addres_co",
                  value: ShowData(state.data, "Addres_co"),
                  type: "text",
                  input: "textarea",
                },
                {
                  label: " شماره تلفن (1) ",
                  size: "col-md-6 ",
                  classNames: "mt-2",
                  placeholder: "شماره تلفن خود را وارد کنید",
                  name: "Tell1_co",
                  value: ShowData(state.data, "Tell1_co"),
                  type: "text",
                },
                {
                  label: " شماره تلفن(2) ",
                  size: "col-md-6 ",
                  classNames: "mt-2",
                  placeholder: "شماره تلفن خود را وارد کنید",
                  name: "Tell2_co",
                  value: ShowData(state.data, "Tell2_co"),
                  type: "text",
                },

                {
                  label: " ایمیل ",
                  size: "col-md-6 ",
                  classNames: "mt-2",
                  placeholder: "ایمیل خود را وارد کنید",
                  name: "Gmail_co",
                  value: ShowData(state.data, "Gmail_co"),
                  type: "text",
                },
                {
                  label: "کد پستی ",
                  size: "col-md-6 ",
                  classNames: "mt-2",
                  placeholder: "",
                  name: "Postnumber_co",
                  value: ShowData(state.data, "Postnumber_co"),
                  type: "text",
                },
                {
                  label: "Location ",
                  size: "col-md-12 ",
                  classNames: "mt-2",
                  placeholder: "",
                  name: "Locatino_co",
                  value: ShowData(state.data, "Locatino_co"),
                  type: "text",
                },
              ]}
              loading={state.loading}
              submit={submit}
              header="ویرایش اطلاعات کمپانی"
              btnName="ثبت تغییرات "
              edit={true}
            />
          ) : (
            <span>اطلاعات موجود نیست</span>
          )}
        </Fragment>
      )}
    </>
  );
}

export default Index;
